"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var provinces = [
    {
        name: 'Ontario',
        abbreviation: 'ON',
        territory: false,
    },
    {
        name: 'Quebec',
        abbreviation: 'QC',
        territory: false,
    },
    {
        name: 'Nova Scotia',
        abbreviation: 'NS',
        territory: false,
    },
    {
        name: 'New Brunswick',
        abbreviation: 'NB',
        territory: false,
    },
    {
        name: 'Manitoba',
        abbreviation: 'MB',
        territory: false,
    },
    {
        name: 'British Columbia',
        abbreviation: 'BC',
        territory: false,
    },
    {
        name: 'Prince Edward Island',
        abbreviation: 'PE',
        territory: false,
    },
    {
        name: 'Saskatchewan',
        abbreviation: 'SK',
        territory: false,
    },
    {
        name: 'Alberta',
        abbreviation: 'AB',
        territory: false,
    },
    {
        name: 'Newfoundland and Labrador',
        abbreviation: 'NL',
        territory: false,
    },
    {
        name: 'Northwest Territories',
        abbreviation: 'NT',
        territory: true,
    },
    {
        name: 'Yukon',
        abbreviation: 'YT',
        territory: true,
    },
    {
        name: 'Nunavut',
        abbreviation: 'NU',
        territory: true,
    },
];
exports.default = provinces;
//# sourceMappingURL=index.js.map